import React, { useState } from 'react';
import { Theme } from '../../../../../Enums/Theme.enum';
import LinkButton from '../../../../../Components/Button/LinkButton';
// @ts-ignore
import styles from './IPLPTemplateListControls.module.scss';
import IPLPTemplateCreateModal from '../IPLPTemplateCreate/IPLPTemplateCreateModal';

interface Props {
	onCreateIPLPTemplate: () => void;
}

const IPLPTemplateListControls: React.FC<Props> = ({
	onCreateIPLPTemplate,
}) => {
	const [isCreateIPLPTemplateOpen, setIsCreateIPLPTemplateOpen] =
		useState(false);

	const handleOnCreate = () => {
		setIsCreateIPLPTemplateOpen(false);
		onCreateIPLPTemplate();
	};

	return (
		<>
			<div className={styles.wrapper}>
				<LinkButton
					title='component.IPLPTemplateListControls.addNew'
					onClick={() => setIsCreateIPLPTemplateOpen(true)}
					theme={Theme.BLUE}
				/>
			</div>
			{isCreateIPLPTemplateOpen && (
				<IPLPTemplateCreateModal
					isOpen
					onClose={() => setIsCreateIPLPTemplateOpen(false)}
					onCreate={handleOnCreate}
				/>
			)}
		</>
	);
};

export default IPLPTemplateListControls;
